import { render, staticRenderFns } from "./CBC_Table_V3.vue?vue&type=template&id=6acdd756&scoped=true"
import script from "./CBC_Table_V3.vue?vue&type=script&lang=js"
export * from "./CBC_Table_V3.vue?vue&type=script&lang=js"
import style0 from "./CBC_Table_V3.vue?vue&type=style&index=0&id=6acdd756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acdd756",
  null
  
)

export default component.exports